import { createSelector } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { QuoteItem } from './models';
import { baseApi } from '@centerpiece/components';

export const quote_item = baseApi
  .enhanceEndpoints({ addTagTypes: ['QuoteItems', 'QuoteItem'] })
  .injectEndpoints({
    endpoints: builder => ({
      getQuoteItems: builder.query<QuoteItem[], { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: 'quote_item',
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'QuoteItem' as const,
                  id,
                })),
                'QuoteItems',
              ]
            : ['QuoteItems'],
      }),
      getQuoteItem: builder.query<QuoteItem, string>({
        query: id => ({
          url: `quote_item/${id}`,
          method: 'GET',
        }),
        providesTags: (result, error, arg) => [{ type: 'QuoteItem', id: arg }],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createQuoteItem: builder.mutation({
        query: request => ({
          url: 'quote_item',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['QuoteItems'],
      }),
      patchQuoteItem: builder.mutation<QuoteItem, QuoteItem>({
        query: request => ({
          url: `quote_item/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteItem', id: arg.id },
        ],
      }),
      updateQuoteItem: builder.mutation<QuoteItem, QuoteItem>({
        query: request => ({
          url: `quote_item/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteItem', id: arg.id },
        ],
      }),
      deleteQuoteItem: builder.mutation<QuoteItem, number>({
        query: id => ({
          url: `quote_item/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [{ type: 'QuoteItem' as const, arg }, 'QuoteItems']
            : ['QuoteItems'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  useGetQuoteItemsQuery,
  useGetQuoteItemQuery,
  useCreateQuoteItemMutation,
  usePatchQuoteItemMutation,
  useUpdateQuoteItemMutation,
  useDeleteQuoteItemMutation,
  usePrefetch: useQuoteItemsPrefetch,
} = quote_item;
const selectQuoteItemsRoot = quote_item.endpoints.getQuoteItems.select({});
export const selectQuoteItems = createSelector(
  selectQuoteItemsRoot,
  quote_item => quote_item.data || []
);
